module.exports = __webpack_public_path__ + "static/media/Golf Hole Ball.7288f29b.svg";